import { useUser } from './useUser'

export const useIsLoggedIn = () => {
  const user = useUser()
  return user?.provider === 'workos'
}
